import { NODE_SPECS, type FlowGraph, type StatusEnteredOptions } from '@ludus/core'

/**
 * What a flow fires on, as far as a catalogue card needs it — the options of
 * the graph's `trigger.status_entered` node.
 *
 * `null` when the graph has no trigger node, or when the one it has is not
 * configured yet, which is the normal state of a brand-new flow: `createFlow`
 * mints a draft whose trigger carries no `statusId`, so a card has to be able
 * to say "not set" rather than invent a stage.
 *
 * The narrowing goes through the node's own spec rather than a cast: `parse`
 * returns `null` exactly when `validate` has something to say, so an
 * unreadable option blob answers "not configured" instead of reaching the
 * sentence. The sentence itself is the card's, because only it has `t`.
 */
export function triggerOptionsOf(graph: FlowGraph): StatusEnteredOptions | null {
  for (const node of graph.nodes) {
    if (node.type !== 'trigger.status_entered') continue
    return NODE_SPECS['trigger.status_entered'].parse(node.options)
  }
  return null
}
